import { ValidationStrategy } from "./validation.strategy";

export class SocialLoginValidationStrategy extends ValidationStrategy {
    public validate(): boolean {
        let isValid = true;

        if (this.isRequired && !this.isDisabled && !this.isHidden) {
            isValid = false;

            const loginObjects = this.attribute.attributes
                .filter(attr => attr.type.toLowerCase() == "object");

            isValid = loginObjects.some(attr => 
                attr.attributes.some(a => 
                    a.key.toLowerCase() == "auth data" && 
                    a.attributes.some(b => 
                        b.key.toLowerCase() == "code" && b.value != null)));
        }

        return isValid
    }
}